import { createContext } from 'react'

const CreateModalContext = createContext()
CreateModalContext.displayName = 'CreateModalContext'

export default CreateModalContext
